function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 5.5l.9 1.8c.8 1.7 2.4 2.8 4.3 3.1l2 .3-1.4 1.4c-1.3 1.3-1.9 3.2-1.6 5l.3 2-1.8-.9c-.8-.4-1.7-.6-2.6-.6-.9 0-1.8.2-2.6.6l-1.9.8.3-2c.3-1.8-.3-3.7-1.6-5l-1.4-1.4 2-.3c1.8-.3 3.4-1.4 4.3-3.1l.8-1.7zm0-5c-.8 0-1.6.4-2 1.2L8 5.8c-.3.6-.9 1.1-1.6 1.2l-4.5.6C.1 7.9-.6 10.1.7 11.3L4 14.5c.5.5.8 1.2.6 1.9L3.8 21c-.2 1.4.9 2.6 2.2 2.6.3 0 .7-.1 1-.3l4-2.1c.3-.2.7-.3 1-.3.3 0 .7.1 1 .3l4 2.1c.3.2.7.3 1 .3 1.3 0 2.4-1.2 2.2-2.6l-.8-4.5c-.1-.7.1-1.4.6-1.9l3.3-3.2c1.3-1.3.6-3.5-1.2-3.7L17.6 7c-.7-.1-1.3-.6-1.7-1.2l-2-4.1C13.6.9 12.8.5 12 .5z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;